import { Store } from '../store/stores/model';

export function getVisibleStores(list: Store[], map: google.maps.Map): Store[] {
  const bounds = map.getBounds();
  return list.filter(({ latlng }) => {
    return bounds.contains(latlng);
  });
}